import { InsuranceConsumer } from '@injectivelabs/chain-consumer'
import { app } from './App'

export const insuranceConsumer = new InsuranceConsumer(
  app.appUrlEndpoint.chainUrl
)
